import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import filters from "./utils/filters";
import ToastEnhancer from "./plugins/toast";
import { VueQueryPlugin } from "@tanstack/vue-query";
import { queryClient } from "./plugins/query-client";
import { requestNotificationPermission } from "./composables/emails/useEmailNotifications";

import ToastContainer from "./components/ui/ToastContainer.vue";
import { Tooltip, VTooltip as VTooltipDirective } from "floating-vue";
import VueAwesomePaginate from "vue-awesome-paginate";
import vue3GoogleLogin from "vue3-google-login";
import VueTelInput from "vue-tel-input";

import "floating-vue/dist/style.css";
import "primeicons/primeicons.css";
import "vue-awesome-paginate/dist/style.css";
import "vue-tel-input/vue-tel-input.css";
import "./assets/style/toast.css";
import "./assets/style/index.css";

const app = createApp(App);

app.component("VTooltip", Tooltip);
app.directive("tooltip", VTooltipDirective);
app.component("ToastContainer", ToastContainer);

app
  .use(VueQueryPlugin, { queryClient })
  .use(vue3GoogleLogin, { clientId: process.env.VUE_APP_GOOGLE_OAUTH_CLIENT_ID })
  .use(VueAwesomePaginate)
  .use(ToastEnhancer)
  .use(VueTelInput)
  .use(store)
  .use(router)
  .mount("#app");

app.config.globalProperties.$filters = filters;

window.addEventListener("unhandledrejection", (event) => {
  console.error("Uncaught promise rejection:", event.reason);
  const reason = event.reason;
  if (
    reason?.code === "ECONNABORTED" ||
    reason?.message?.includes("timeout") ||
    reason?.message === "Network Error" ||
    reason?.code === "ERR_NETWORK" ||
    reason?._handled === true
  ) {
    event.preventDefault();
  }
});

window.addEventListener("error", (event) => {
  console.error("Uncaught error:", event.error);
  if (event.error?.code === "ECONNABORTED" || event.error?.message?.includes("timeout")) {
    event.preventDefault();
  }
  if (
    event.error?.name === "ChunkLoadError" ||
    /Loading chunk \d+ failed/.test(event.error?.message ?? "")
  ) {
    event.preventDefault();
    window.location.reload();
  }
});

requestNotificationPermission();
